import { render, staticRenderFns } from "./RoutingStatusSection.vue?vue&type=template&id=be03f228&scoped=true&"
import script from "./RoutingStatusSection.vue?vue&type=script&lang=js&"
export * from "./RoutingStatusSection.vue?vue&type=script&lang=js&"
import style0 from "./RoutingStatusSection.vue?vue&type=style&index=0&id=be03f228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03f228",
  null
  
)

export default component.exports